const _version = "2.15.0"
function version() {
    return _version
}
export default version
